import { BaseChartGenerator } from '@/core/charts/baseChart.service'
import { IChartGenerator } from '@/core/charts/ichartgenerator.model'

class LineChart extends BaseChartGenerator implements IChartGenerator {
  protected get Type (): string { return 'spline' }
  protected get OverviewType (): string { return 'areaspline' }
}

export default new LineChart()
